/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FlexLayout from '@ba-ui-toolkit/flexlayout';
import ProgressIndicator from '@ba-ui-toolkit/progressindicator';
import CarbonTile from './tile/CarbonTile';
import Label from '@ba-ui-toolkit/label';
import styles from './TileView.scss';

const tileViewClassName = styles.tileViewClassName.replace(/"/g, '');

export default class TileView extends Component {
    static propTypes = {
        /** Custom class name(s) */
        className: PropTypes.string,
        /** A list of the tiles formatted properly for use from the ca-ui-toolkit */
        tilesGroup: PropTypes.array,
        /** boolean to display progress indicator  */
        loaded: PropTypes.bool,
         /** boolean to specify folder or asset  */
        container: PropTypes.bool,
        /** boolean to specify tile background color  */
        light: PropTypes.bool
    };

    state = {
        tilesGroup: [],
        loaded: false
    };

    render() {
        const { 
            className, 
            tilesGroup, 
            loaded,
            container,
            light } = this.props;

        let tiles;
        loaded && tilesGroup && tilesGroup.length > 0 && tilesGroup.forEach(function(group) {
            if (group.tiles.length >0 ) {
                tiles = group.tiles.map((tile) =>
                <CarbonTile 
                    className= {`${tileViewClassName}__tile`} 
                    container = {container}
                    key={tile.label} 
                    content={tile} 
                    onMenu={(e) => {tile.onMenu(e, tile.id)}} 
                    ellipsisIcon = {tile.ellipsisIcon} 
                    ellipsisTooltipLabel = {tile.ellipsisTooltipLabel}
                    onAction = {(e) => { tile.openTile(e, tile.id) } }
                    light = {light}
                >
                </CarbonTile>
                );
            }
        });
        
        return (
                loaded ? 
                <FlexLayout direction='column' className={`${tileViewClassName} ${className}`}>
                    { tiles ?
                        <div className= {`${tileViewClassName}__asset`}>
                            <Label className= {`${tileViewClassName}__label`}
                                    label = {tilesGroup[0].title}
                                />
                            <FlexLayout direction="row" wrap="wrap" className="tileFlexLayout">
                                {   
                                   tiles
                                }
                            </FlexLayout>
                        </div> : null
                    }
                </FlexLayout>
                : 
                <div className={`${tileViewClassName}__loading`}>
                    <ProgressIndicator size="large" variant="circle" />
                </div>
        );
    }
}
